<script lang="ts">
    import type { EntityPrefab } from "@workadventure/map-editor";
    import { triggerClickOnEnterOrSpace } from "../../../../Utils/svelte-a11y";

    interface Props {
        entityPrefabsPositions: EntityPrefab[];
        selectedEntity: EntityPrefab;
        onPickItem: (entity: EntityPrefab) => void;
    }

    let { entityPrefabsPositions, selectedEntity, onPickItem }: Props = $props();
</script>

{#if entityPrefabsPositions.length > 1}
    <p class="m-0 text-xxs">Положения</p>
    <div class="flex flex-row gap-2">
        {#each entityPrefabsPositions as item (item.id)}
            <div
                class="hover:cursor-pointer"
                role="button"
                tabindex="0"
                aria-pressed={item.imagePath === selectedEntity?.imagePath}
                aria-label={item.name}
                onclick={() => onPickItem(item)}
                onkeydown={triggerClickOnEnterOrSpace}
            >
                <img
                    draggable="false"
                    class={`hover:cursor-pointer item-image max-w-[32px] ${
                        item.imagePath === selectedEntity?.imagePath ? "border-solid border-yellow-400 rounded-sm" : ""
                    }`}
                    src={item.imagePath}
                    alt={item.name}
                />
            </div>
        {/each}
    </div>
{/if}
